/* Shared reveal-on-scroll. Adds .is-revealed to any .hx-reveal element when it
   enters the viewport. Runs once per page (guarded), re-scans on theme-editor
   section loads, and reveals immediately if IntersectionObserver is unavailable. */
(function () {
  if (window.__hxRevealInit) return;
  window.__hxRevealInit = true;

  function reveal() {
    var els = document.querySelectorAll('.hx-reveal:not(.is-revealed)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-revealed');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', reveal);
})();
